import { connect } from 'react-redux';
import StripeElements from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(StripeElements);
